// Asal: Startseite – nächster Abholtermin im Startbild und Terminliste, live aus dem Orangen Hub. Ohne Bibliotheken.
(() => {
  const next = document.querySelector('[data-asal-next]');
  const list = document.querySelector('[data-asal-dates]');
  if (!next && !list) return;

  const date = (d, opts) => new Date(d + 'T12:00:00').toLocaleDateString('de-DE', opts);
  const long = d => date(d, { weekday: 'long' }) + ', ' + date(d, { day: '2-digit', month: '2-digit', year: 'numeric' });
  const deadline = dl => {
    if (!dl) return '';
    const [d, t] = dl.split('T');
    return `Bestellschluss ${long(d)}, ${t} Uhr`;
  };
  const state = d => {
    const free = d.slots.reduce((n, s) => n + s.free, 0);
    if (!d.bookable) return { text: 'Buchung startet bald', cls: 'is-soon' };
    if (free === 0) return { text: 'ausgebucht', cls: 'is-full' };
    if (free < 30) return { text: 'fast ausgebucht', cls: 'is-few' };
    return { text: 'Plätze frei', cls: '' };
  };
  const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; };

  const asalRun = () => (window.AsalPlace ? window.AsalPlace.load() : Promise.reject(new Error('AsalPlace fehlt'))).then(({ days = [] }) => {
    if (next && !days.length) next.hidden = true;
    if (next && days.length) {
      const d = days.find(x => x.bookable && x.slots.some(s => s.available)) || days[0];
      const ic = el('span', 'asal-next__icon');
      ic.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>';
      const txt = el('span', 'asal-next__txt');
      txt.append(el('small', '', 'Nächster Abholtermin'), el('strong', '', long(d.date)), el('em', d.bookable ? 'is-open' : '', d.bookable ? deadline(d.deadline).replace('Bestellschluss', 'Bestellen bis') : 'Buchung startet bald'));
      next.replaceChildren(ic, txt);
      next.hidden = false;
    }
    if (list) {
      if (!days.length) { list.replaceChildren(el('p', 'asal-dates__empty', list.dataset.empty)); return; }
      const multi = new Set(days.map(d => d.place && d.place.id)).size > 1;
      list.replaceChildren(...days.slice(0, 8).map(d => {
        const s = state(d);
        const free = d.slots.reduce((n, x) => n + x.free, 0);
        const card = el('div', 'asal-cal ' + s.cls);
        const month = el('div', 'asal-cal__month');
        month.innerHTML = '<svg class="asal-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>';
        month.prepend(el('span', '', date(d.date, { month: 'long' })));
        const body = el('div', 'asal-cal__body');
        body.append(el('span', 'asal-cal__day', date(d.date, { day: 'numeric' })), el('span', 'asal-cal__wd', date(d.date, { weekday: 'long' })));
        if (multi && d.place) body.append(el('span', 'asal-cal__place', d.place.name));
        const label = !d.bookable ? 'Buchung startet bald' : free === 0 ? 'ausgebucht' : `noch ${free} Plätze frei`;
        body.append(el('span', 'asal-cal__state ' + s.cls, label));
        if (d.deadline) body.append(el('span', 'asal-cal__dl', deadline(d.deadline).replace('Bestellschluss', 'bestellen bis')));
        card.append(month, body);
        return card;
      }));
      const place = (days.find(d => d.place) || {}).place;
      const box = document.querySelector('[data-asal-placebox]');
      if (place && box) {
        box.querySelector('[data-asal-place-address]').textContent = [place.name, place.address].filter(Boolean).join(' · ');
        if (place.info) { box.querySelector('[data-asal-place-info]').textContent = place.info; box.querySelector('[data-asal-place-info-row]').hidden = false; }
        const map = box.querySelector('[data-asal-place-map]');
        if (map) { map.href = place.map || 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(place.address || place.name); map.hidden = false; }
      }
    }
  }).catch(() => { if (list) list.replaceChildren(el('p', 'asal-dates__empty', list.dataset.empty)); });
  asalRun();
  document.addEventListener('asal:place', asalRun);
})();
